import { useEffect, useState } from "react";
import api, { apiError, fmtNum } from "../../../lib/api";
import { toast } from "sonner";

export function AdminTransfers() {
  const [listings, setListings] = useState([]);
  const [completing, setCompleting] = useState(null);
  const [cf, setCf] = useState({ buyer_user_id: "", units: "", price_per_unit: "" });
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/listings").then((r) => setListings(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const patch = async (id, status) => {
    try {
      await api.patch(`/admin/listings/${id}`, { status });
      toast.success("Updated.");
      load();
    } catch (e) { toast.error(apiError(e)); }
  };

  const startComplete = (l) => {
    setCompleting(l.listing_id);
    setCf({
      buyer_user_id: l.interests?.[0]?.buyer_user_id || "",
      units: String(l.units),
      price_per_unit: l.asking_price_per_unit ? String(l.asking_price_per_unit) : "",
    });
  };

  const complete = async (id) => {
    setBusy(true);
    try {
      await api.post(`/admin/listings/${id}/complete`, {
        buyer_user_id: cf.buyer_user_id, units: Number(cf.units), price_per_unit: Number(cf.price_per_unit),
      });
      toast.success("Transfer completed. Portfolios updated and both members notified.");
      setCompleting(null);
      load();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="space-y-10" data-testid="admin-transfers-list">
      {listings.map((l) => (
        <div key={l.listing_id} className="hairline pt-6">
          <div className="flex flex-wrap gap-x-10 gap-y-2 items-baseline justify-between">
            <div>
              <span className="t-body text-bone">{l.company}</span>
              <span className="t-small text-muted-s ml-3">{l.share_class}, {fmtNum(l.units)} units
                {l.asking_price_per_unit ? `, asking USD ${l.asking_price_per_unit.toFixed(2)}` : ""}</span>
            </div>
            <span className="t-small text-muted-s">Seller: {l.seller_email}</span>
            <span className="t-label capitalize">{l.status.replace("_", " ")}</span>
            <div className="space-x-4">
              {l.status !== "completed" && l.status !== "withdrawn" && (
                <>
                  <button onClick={() => patch(l.listing_id, "under_review")} className="t-label hover:!text-[#E8E6E1]">In process</button>
                  <button onClick={() => patch(l.listing_id, "closed")} className="t-label hover:!text-[#E8E6E1]" data-testid={`close-listing-${l.listing_id}`}>Close</button>
                  <button onClick={() => startComplete(l)} className="t-label hover:!text-[#E8E6E1]" data-testid={`complete-listing-${l.listing_id}`}>Complete</button>
                </>
              )}
            </div>
          </div>
          {completing === l.listing_id && (
            <div className="mt-4 max-w-xl space-y-3" data-testid="complete-transfer-form">
              <span className="t-label">Complete transfer, moves units from seller to buyer</span>
              <select className="input-solera" value={cf.buyer_user_id}
                onChange={(e) => setCf({ ...cf, buyer_user_id: e.target.value })} data-testid="complete-buyer-select">
                <option value="">Select buyer from interested members</option>
                {l.interests?.map((i) => (
                  <option key={i.interest_id} value={i.buyer_user_id}>{`${i.buyer_email}, ${fmtNum(i.units)} units requested`}</option>
                ))}
              </select>
              <div className="grid grid-cols-2 gap-3">
                <input className="input-solera fig" type="number" placeholder="Units" value={cf.units}
                  onChange={(e) => setCf({ ...cf, units: e.target.value })} data-testid="complete-units-input" />
                <input className="input-solera fig" type="number" step="0.01" placeholder="Price per unit, USD" value={cf.price_per_unit}
                  onChange={(e) => setCf({ ...cf, price_per_unit: e.target.value })} data-testid="complete-price-input" />
              </div>
              <div className="flex gap-3">
                <button className="btn-ghost" onClick={() => setCompleting(null)}>Cancel</button>
                <button className="btn-primary" disabled={busy || !cf.buyer_user_id || !cf.units || !cf.price_per_unit}
                  onClick={() => complete(l.listing_id)} data-testid="complete-submit-button">
                  {busy ? "Completing" : "Complete transfer"}
                </button>
              </div>
            </div>
          )}
          {l.interests?.length > 0 && (
            <table className="table-solera mt-4">
              <thead><tr><th>Interested member</th><th className="num">Units</th><th>Message</th><th>Date</th></tr></thead>
              <tbody>
                {l.interests.map((i) => (
                  <tr key={i.interest_id}>
                    <td className="text-muted-s">{i.buyer_email}</td>
                    <td className="num text-bone">{fmtNum(i.units)}</td>
                    <td className="text-muted-s t-small">{i.message || ""}</td>
                    <td className="text-muted-s t-small fig">{i.created_at?.slice(0, 10)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      ))}
      {listings.length === 0 && <p className="t-small text-muted-s">No listings.</p>}
    </div>
  );
}
